import { useEffect, useState } from 'react';
import { apiJson } from '../api/client.js';
import { downloadPdfDocument } from '../components/PdfDocumentsPanel.jsx';
import { formatDateTime } from '../utils/formatDate.js';

export function MyPdfDocumentsPage() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiJson('/api/my/pdf-documents')
      .then(setItems)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  const openDoc = async (doc) => {
    try {
      const blob = await downloadPdfDocument(doc.id, 'my');
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank', 'noopener,noreferrer');
      setTimeout(() => URL.revokeObjectURL(url), 60_000);
    } catch (e) {
      setError(e.message);
    }
  };

  if (loading) return <p className="muted">Loading shared PDFs…</p>;

  return (
    <div>
      <h2 style={{ marginTop: 0 }} data-tour="page-title">Shared PDFs</h2>
      <p className="muted small">PDF documents your agency shared with you.</p>
      {error ? <p className="err">{error}</p> : null}
      <div className="auth-card flat">
        {items.length === 0 ? (
          <p className="muted" style={{ marginBottom: 0 }}>No shared PDFs yet.</p>
        ) : (
          <ul className="list-unstyled mb-0">
            {items.map((doc) => (
              <li key={doc.id} style={{ padding: '0.75rem 0', borderBottom: '1px solid #e2e8f0' }}>
                <button type="button" className="btn btn-link p-0" onClick={() => void openDoc(doc)}>
                  {doc.title}
                </button>
                {doc.description ? <div className="small">{doc.description}</div> : null}
                <div className="muted small">
                  {doc.project_name ? `${doc.project_name} · ` : ''}
                  {doc.updated_at ? formatDateTime(doc.updated_at) : ''}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
